import React from "react";
import App from "../Layouts/AppLayout";
import { Section } from "../Components";

export default function TermsAndConditions() {
  const contents = [
    {
      title: "Introduction",
      body: (
        <p>
          The use of this site is governed by the policies, terms and conditions set forth
          below, please read them carefully. Your use of this site indicates your acceptance of
          these terms and conditions. PayOnDelivery reserves the right to make changes to
          this site and these terms and conditions at any time.
        </p>
      ),
      summary: "Read carefully, you accept these terms to use this site."
    },
    {
      title: "Copyright & Trademark Notice",
      body: (
        <p>
          This site is owned and operated by PayOnDelivery. Unless otherwise specified, all
          materials appearing on this site, including the text, site design, logos, graphics,
          icons, and images, as well as the selection, assembly and arrangement thereof, are
          the sole property of PayOnDelivery. Copyright © 2017. ALL RIGHTS RESERVED.
          <br />
          All software used on this site is licensed by, or is the sole property of, PayOnDelivery
          or those vendors supplying the software. No materials from this site may be copied,
          reproduced, modified, republished, uploaded, posted, transmitted, or distributed in
          any form or by any means without the prior written permission of PayOnDelivery.
          <br />
          PayOnDelivery is a registered trademark, trademark or service mark of PayOnDelivery.
          All custom graphics, icons, logos and service names are registered trademarks, trademarks,
          or service marks of PayOnDelivery. The use of any PayOnDelivery trademark or service mark
          without the express written consent of PayOnDelivery is strictly prohibited.
        </p>
      ),
      summary: "Everything you see here is our property, unless otherwise specified."
    },
    {
      title: "Delivery Guarantee",
      body: (
        <p>
          All shipments through PayOnDelivery are guaranteed to be delivered to the validated
          address defined by the buyer. PayOnDelivery will not charge your credit card until
          the shipment is delivered to the stated destination address and the allocated 24-hour
          return period has passed. <br />
          If (for any unforeseen reason) the shipment is not delivered, then you will not be charged.
        </p>
      ),
      summary: "We will not charge your card until after the purchase is delivered."
    },
    {
      title: "Suitable Packaging",
      body: (
        <p>
          When selling with PayOnDelivery Same Day, please ensure you are available for pickup
          or make alternative arrangements if necessary to allow your package to be picked up. <br />
          There is an $11.00 charge if you're not available when the driver comes to pick up your package.
        </p>
      ),
      summary: "Please be ready to ship an order if you accept it."
    },
    {
      title: "Delivery Times And Service Type",
      body: (
        <p>
          The estimated delivery date of same-day shipments is displayed to the user when the shipment
          is created. By using this service, the user agrees that the estimated delivery time is a good
          faith estimate of when delivery will be accomplished and is applicable only to the particular
          service type chosen by the user for the order.
        </p>
      ),
      summary: "Delivery times are estimates."
    },
    {
      title: "Refund Policy",
      body: (
        <p>
          If the shipment is not delivered in the stated condition, then you can request a refund through
          PayOnDelivery within 24 hours of delivery confirmation. The refund will be assessed on the stated
          value of the shipment.
        </p>
      ),
      summary: "Refund unsatisfactory shipments within 24 hours of delivery."
    },
    {
      title: "Order Acceptance Policy",
      body: (
        <p>
          PayOnDelivery reserves the right at any time after receipt of your order to accept or decline
          your order for any reason. Orders placed over $250.00(USD) are subject to pre-approval with an
          acceptable method of payment, as established by our credit and fraud avoidance department. <br />
          We may require additional verifications or information before accepting any order.
        </p>
      ),
      summary: null
    },
    {
      title: "Jurisdiction & Venue",
      body: (
        <p>
          You agree that any legal action brought against PayOnDelivery shall be governed by the laws of
          the State of Texas without regard to its conflict of law principles. You agree that the sole
          jurisdiction and venue for any litigation arising from your use of or orders made on PayOnDelivery
          website shall be an appropriate Federal or State court located in Texas.
        </p>
      ),
      summary: "We're governed by the laws of the state of Texas."
    }
  ];


  return (
    <App>
      <Section >
        <h1 className="tw-text-center">Terms & conditions</h1>
      </Section>

      <div className="tw-space-y-4 tw-space-y-8 tw-pb-8 md:tw-pb-16">
        {contents.map((_, i) =>
          <Section key={i} pad={false} className="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-4">
            <div className="md:tw-col-span-2">
              <h5 className="tw-text-primary">{_.title}</h5>
              {_.body}
            </div>

            <div>
              {_.summary && <>
                <h5 className="tw-uppercase tw-text-primary">In summary</h5>
                <p>{_.summary}</p>
              </>}
            </div>
          </Section>
        )}
      </div>
    </App>
  );
}
